import React, { Component } from 'react';
import classnaems from 'classnames';

import './EntityListWithGlobal.css';

import EntityList_0 from './EntityList/EntityTypeList/EntityList_0';
import EntityList_1 from './EntityList/EntityTypeList/EntityList_1';

class EntityListWithGlobal extends Component {

  static defaultProps = {
    topicId : -1,
  }

  state = {
    selectedTab : 0, // 0: global-entity , 1: topic-entity
    entityType : 0,
  }
  render() { 

    const globalEntityTabClass = classnaems('tab-btn', {
      'selected' : this.state.entityType === 0,
    })
    const normalEntityTabClass = classnaems('tab-btn', {
      'selected' : this.state.entityType === 1,
    })

    const renderList = (tabType = this.state.selectedTab) => {
      switch(tabType){
        case 0:
        return ( <EntityList_0
          topicId={this.props.topicId}
          isForView={true} /> )
        break;

        case 1:
        return ( <EntityList_1
          topicId={this.props.topicId}
          isForView={true} /> )
        break;

        default:
        return ( <p> 선택된 탭이 없습니다. </p> );
      }
    }

    return (
      <div className="entity-list with-global">
        <div className="tab-area">
          <div className="global-entity-tab">
            <button className={globalEntityTabClass}>
              글로벌 엔티티
            </button>
          </div>
          <div className="topic-entity-tab">
          <button className={normalEntityTabClass}
            >
            엔티티
          </button>
          </div>
        </div>
        <div className="list-area">
          {renderList()}
        </div>
      </div>
    );
  }
}
 
export default EntityListWithGlobal;